// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FormTextarea_wrapper","info":"FormTextarea_info"};